var _defs, _path, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgAvatar21(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "_50_Kids_Icons-34",
    "data-name": "50_Kids_Icons-34",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 80,
    height: 80,
    viewBox: "0 0 80 80",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1297",
    "data-name": "Path 1297",
    d: "M0,40A40,40,0,1,1,40,80,40,40,0,0,1,0,40Z"
  })))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_1294",
    "data-name": "Path 1294",
    d: "M0,40A40,40,0,1,1,40,80,40,40,0,0,1,0,40Z",
    fill: "#a18fa1"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_4639",
    "data-name": "Group 4639"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_4626",
    "data-name": "Group 4626",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1295",
    "data-name": "Path 1295",
    d: "M145.788,238.491c1.13,2.677.515,5.278-1.374,5.81s-4.337-1.205-5.467-3.882-.515-5.278,1.374-5.811S144.658,235.815,145.788,238.491Z",
    transform: "translate(-116.759 -197.87)",
    fill: "#e38a5b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1296",
    "data-name": "Path 1296",
    d: "M329.963,238.491c-1.13,2.677-.514,5.278,1.375,5.81s4.337-1.205,5.466-3.882.515-5.278-1.374-5.811S331.094,235.815,329.963,238.491Z",
    transform: "translate(-277.929 -197.87)",
    fill: "#e38a5b"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_4627",
    "data-name": "Group 4627",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_147",
    "data-name": "Ellipse 147",
    cx: 19.811,
    cy: 18.135,
    rx: 19.811,
    ry: 18.135,
    transform: "translate(20.721 9.669)",
    fill: "#3d2a3d"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_4628",
    "data-name": "Group 4628",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1299",
    "data-name": "Path 1299",
    d: "M118.724,421.249l-.009-.145c0-8.821-3.3-17.367-7.334-18.995l-17.171-6.918a22.748,22.748,0,0,0-14.668-.019l-17.417,6.959c-4.035,1.615-7.337,10.152-7.337,18.973l-.009.145Z",
    transform: "translate(-46.219 -332.409)",
    fill: "#e38a5b"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_4629",
    "data-name": "Group 4629",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1301",
    "data-name": "Path 1301",
    d: "M227.408,272.134a6.856,6.856,0,0,1-6.856,6.856h-.831a6.856,6.856,0,0,1-6.856-6.856v-17.66a6.856,6.856,0,0,1,6.856-6.856h.831a6.856,6.856,0,0,1,6.856,6.856Z",
    transform: "translate(-179.605 -208.928)",
    fill: "#e38a5b"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_4631",
    "data-name": "Group 4631",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_4630",
    "data-name": "Group 4630",
    transform: "translate(25.777 14.765)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1303",
    "data-name": "Path 1303",
    d: "M194.48,124.91a11.37,11.37,0,0,1-11.37,11.37H176.34a11.37,11.37,0,0,1-11.37-11.37V105.866A11.37,11.37,0,0,1,176.34,94.5h6.771a11.37,11.37,0,0,1,11.37,11.37Z",
    transform: "translate(-164.97 -94.496)",
    fill: "#f5b68c"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_4632",
    "data-name": "Group 4632",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_148",
    "data-name": "Ellipse 148",
    cx: 1.706,
    cy: 1.706,
    r: 1.706,
    transform: "translate(33.168 37.902)",
    fill: "#572020"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_149",
    "data-name": "Ellipse 149",
    cx: 1.706,
    cy: 1.706,
    r: 1.706,
    transform: "translate(44.483 37.902)",
    fill: "#572020"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_4633",
    "data-name": "Group 4633",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1306",
    "data-name": "Path 1306",
    d: "M165.869,79.272c-9.566,0-17.321,8.405-17.321,18.774a19.9,19.9,0,0,0,2.349,9.444L152.618,92.9h26.5l1.724,14.6a19.9,19.9,0,0,0,2.348-9.444C183.19,87.677,175.435,79.272,165.869,79.272Z",
    transform: "translate(-125.337 -66.886)",
    fill: "#3d2a3d"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_4634",
    "data-name": "Group 4634",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1308",
    "data-name": "Path 1308",
    d: "M246.649,274.928a2.628,2.628,0,0,1-5.13.593,2.782,2.782,0,0,0-.126.783,2.814,2.814,0,1,0,5.629,0A2.776,2.776,0,0,0,246.649,274.928Z",
    transform: "translate(-203.675 -231.971)",
    fill: "#e38a5b"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_4635",
    "data-name": "Group 4635",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1310",
    "data-name": "Path 1310",
    d: "M118.714,435.37c0-8.821-3.3-17.367-7.334-18.995l-13.653-5.5a12.058,12.058,0,0,1-21.928.058L62.123,416.4c-4.035,1.615-7.337,10.152-7.337,18.973l-.009.145h63.946Z",
    transform: "translate(-46.218 -346.676)",
    fill: "#2961a5"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_4637",
    "data-name": "Group 4637",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_4636",
    "data-name": "Group 4636",
    transform: "translate(34.608 48.205)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1312",
    "data-name": "Path 1312",
    d: "M221.494,308.509c0,.032,0,.068,0,.1a5.924,5.924,0,1,0,11.847,0c0-.034,0-.07,0-.1Z",
    transform: "translate(-221.492 -308.509)",
    fill: "#a91935"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1313",
    "data-name": "Path 1313",
    d: "M233.541,308.509v.507a1.86,1.86,0,0,0,1.86,1.862h6.094a1.861,1.861,0,0,0,1.863-1.862v-.507Z",
    transform: "translate(-231.658 -308.509)",
    fill: "#fff"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_4638",
    "data-name": "Group 4638",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_150",
    "data-name": "Ellipse 150",
    cx: 15.625,
    cy: 7.925,
    rx: 15.625,
    ry: 7.925,
    transform: "translate(24.764 19.475)",
    fill: "#3d2a3d"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAvatar21);
export default __webpack_public_path__ + "static/media/avatar21.43bb576251099e911bfbe2d3cce9a8bd.svg";
export { ForwardRef as ReactComponent };